import config from '@/config.js'

const UnleashFlagTurnOnTimeMapProd = {
  'audience-wordcloud-emqx': new Date(Date.UTC(2024, 11, 10, 7, 0, 0)), // 14h UTC+7 10/12/2024
  'kv-sync-emqx-for-live-stats': new Date(Date.UTC(2025, 0, 16, 0, 0, 0)), // 7h UTC+7 16/1/2025
}

const UnleashFlagTurnOnTimeMapDev = {
  'audience-wordcloud-emqx': new Date(Date.UTC(2024, 11, 10, 7, 0, 0)), // 14h UTC+7 10/12/2024
  'kv-sync-emqx-for-live-stats': new Date(Date.UTC(2025, 0, 16, 0, 0, 0)), // 18h00 UTC+7 25/12/2024
}

const UnleashFlagTurnOnTime = config.env === 'production' ? UnleashFlagTurnOnTimeMapProd : UnleashFlagTurnOnTimeMapDev

export default UnleashFlagTurnOnTime
